<template>
    <div :class="fieldErrors[id] ? 'error' : ''">
        <label class="block text-gray-700 text-sm font-semibold  mb-2" :for="id" v-if="label">{{label}}</label>
        <input v-bind:value="value"
               v-on:input="$emit('input', $event.target.value)"
               :class="[classes(), fieldErrors[id] ? 'border-red-500' : '']"
               :disabled="disabled"
               :id="id"
               :type="!$attrs.type ? 'text' : $attrs.type"
               :placeholder="$attrs.placeholder"
               :required="$attrs.required"
               :readonly="$attrs.readonly"
               :min="$attrs.min"
               :max="$attrs.max"
               :step="$attrs.step"
               autocomplete="off"
               class="appearance-none block w-full text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"/>
        <div v-if="fieldErrors[id]" class="text-red-500 text-xs italic">
            {{$fieldError(id, fieldErrors[id])}}
        </div>
    </div>
</template>

<script>

import errorsMixin from './../mixins/errors-mixin.js';

export default {
        mixins: [errorsMixin],
        props: {
            id: {
                type: String,
                required: true
            },
            label: {
                type: String
            },
            value: {},
            disabled: {
                type: Boolean,
                default: false
            },
            fieldErrors: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            size: {
                type: String,
                default: 'md'
            },
        },
        methods: {
            classes() {
                let paddingMap = {
                    xs: 'py-1 px-2',
                    sm: 'py-2 px-3',
                    md: 'py-3 px-4',
                    lg: 'py-4 px-5',
                };
                let textSizesMap = {
                    xs: 'text-xs',
                    sm: 'text-sm',
                    md: 'tert-base',
                    lg: 'text-lg',
                };

                let padding = paddingMap[this.size];
                let text = textSizesMap[this.size];
                let disabled = this.disabled ? 'text-gray-300 cursor-not-allowed' : 'bg-gray-200';

                return `${text} ${padding} ${disabled}`
            }
        },
    }
</script>

<style scoped>

</style>
